export const MEDICAL_APPOINTMENT_ACCESS = {
  GET: "consulta citas medicas"
};

export const MEDICAL_APPOINTMENT_STATES = {
  CANCELED: "Cancelada",
  ASSIGNED: "Asignada",
  COMPLETED: "Completada"
};
